<template>
  <el-form :model="form" :rules="rules" ref="form" label-position="top" class="category-attr">
    <template v-if="propConfigs.length">
      <template v-for="(item) in propConfigs">
        <div :class="{'attr-item': true, 'long-attr-item': item.propInputType === 'MATERIAL'}" v-if="!item.preConstraint || preConstraintCanshow(item.prePropValues)" :key="item.propId">
          <el-form-item
            :prop="`${item.propId}`"
            :label="item.propName">
            <PropSelect
              v-if="['CHECKBOX', 'RADIO'].includes(item.propInputType)"
              v-model="form[item.propId]"
              :multiple="item.propInputType === 'CHECKBOX'"
              :multipleLimit="item.propValueMaximum"
              :allowCreate="item.customInput"
              :propId="item.propId"
              :propName="item.propName"
              :categoryId="categoryId"
              ></PropSelect>
            <MaterialSelect
              v-else-if="item.propInputType === 'MATERIAL'"
              v-model="form[item.propId]"
              :propId="item.propId"
              :propName="item.propName"
              :categoryId="categoryId"
              ></MaterialSelect>
            <el-date-picker
              v-else-if="item.propInputType === 'DATETIMERANGE'"
              v-model="form[item.propId]"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-date-picker
              v-else-if="item.propInputType === 'DATETIME'"
              v-model="form[item.propId]"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
            <el-input-number
              v-else-if="item.propInputType === 'NUMBER'"
              v-model="form[item.propId]"
              :controls="false"
            ></el-input-number>
            <div v-else-if="item.propInputType === 'INVALID_PROP_INPUT_TYPE'">无效值</div>
            <MutiImgUpload
              :ref="`${item.propId}_img`"
              v-else-if="item.propInputType === 'IMAGE'"
              v-model="form[item.propId]"
              :limitSize="2 * 1024 * 1024"
              :size="100"
              limitSuffix=".jpg,.png,.jpeg,.webp,.bmp"
              :mainImgNums="0"/>
            <el-input
              style="width:156px;"
              v-else
              v-model="form[item.propId]"></el-input>
            <!-- 是否有单位 -->
            <el-select
              v-if="item.unitProp && item.unitProp.length"
              style="width:65px;"
              placeholder="单位"
              v-model="unitForm[item.propId]"
              value-key="unitPropValueId"
              @change="handleUnitChange(item.propId)">
              <el-option
                v-for="unit in item.unitProp"
                :key="unit.unitPropValueId"
                :value="unit"
                :label="unit.unitPropValueName"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </template>
    </template>
    <div v-else>暂无属性</div>
    <template>
       <span class="update-brand">找不到商品属性？
            <el-link :underline="false" @click="fetch_props(true)">刷新数据</el-link>
        </span>
    </template>
  </el-form>
</template>

<script>
// import { getCategoryAndPropertiesMatch } from '@/servers/prod/center'
import {getCategoryProps, _filterInvalidImg} from '@/servers/prod/center/kuaishou.js'
import PropSelect from './PropSelect.vue'
import MaterialSelect from './MaterialSelect.vue'
import MutiImgUpload from '@/components/Uploads/MutiImgUpload'
import _ from 'lodash'
import { mapActions } from 'vuex'
// 1-文本 2-checkbox 3-数字 4-邮箱 5-日期 6-url地址 7-时间范围 8-单选框 9-图片
// 根据inputType取对应的valuekey
const valueKeyMaps = {
  '1': 'textPropValue',
  '3': 'textPropValue',
  '4': 'textPropValue',
  '6': 'textPropValue',
  '2': 'checkBoxPropValuesList',
  '5': 'datetimeTimestamp',
  '7': 'dateRange',
  '8': 'radioPropValue',
  '9': 'imagePropValues',
  '10': 'materialPropValuesList',
}

const inputTypeMaps = {
  'TEXT': '1',
  'CHECKBOX': '2',
  'NUMBER': '3',
  'EMAIL': '4',
  'DATETIME': '5',
  'URL': '6',
  'DATETIMERANGE': '7',
  'RADIO': '8',
  'IMAGE': '9',
  'MATERIAL': '10'
}

export default {
  name: 'kuaishouCp',
  model: {
    prop: 'values',
    event: 'change'
  },
  components: {
    PropSelect,
    MaterialSelect,
    MutiImgUpload
  },
  props: {
    values: {
      required: true
    },
    categoryIds: {
      type: Array,
      default() {
        return []
      }
    },
    baseItemId: [Number, String],
  },
  data() {
    return {
      form: {},
      unitForm: {},
      propConfigs: [],
      rules: {},
      categoryIdChange: false,
      firstLoad: true,
      categoryId: '',
      cid: '',
      // 用于校验表单品牌变更，触发外部的商品名称校验
      brandPropConfig: null,
      // matchPropValues: [],
      // showMatchTip: false,
      // matchPropNames: [],
    }
  },
  watch: {
    categoryIds: {
      handler(v) {
        this.categoryId = !v.length ? '' : v[v.length - 1]
      },
      immediate: true
    },
    categoryId: {
      handler(v, o) {
        this.propConfigs = []
        this.rules = {}
        this.categoryIdChange = !!o
        this.cid = v;
        v && this.fetch_props()
        // this.getCategoryPropertiesMatchData();
      },
      immediate: true
    },
    values: {
      immediate: true,
      handler(v) {
        // 根据values生产form
        if (!v || !v.length) {
          this.form = {}
          return;
        }
        v.forEach(item => {
          let _value = item[valueKeyMaps[item.inputType]]
          if (~~item.inputType === 7) { // 时间范围是对象 需要转数组
            _value = [_value.startTimeTimestamp, _value.endTimeTimestamp]
          }
          if (valueKeyMaps[item.inputType] === 'textPropValue') {
            // 文本类从服务器只存null值需要转为空字符串
            _value = _value || ''
          }
          if (~~item.inputType === 9) { // 图片类型
            // 默认值需要是数组
            _value = _value || []
          }
          if (item.unitPropValueId) {
            // 若有单位
            this.$set(this.unitForm, item.propId, {unitPropValueId: item.unitPropValueId, unitPropValueName: item.unitPropValueName})
          }
          this.$set(this.form, item.propId, _value)
        })
      }
    },
    form: {
      deep: true,
      handler(v) {
        if (!this.values?.length) return;
        const _values = this.values.map(item => {
          const _item = { ...item };
          let _new_value = v[item.propId];
          const inputType = ~~item.inputType;
          const valueKey = valueKeyMaps[item.inputType];
          // 处理特殊类型转换
          if (inputType === 7 && Array.isArray(_new_value)) { // 时间范围数组 转 对象
            const [startTimeTimestamp, endTimeTimestamp] = _new_value;
            _new_value = { startTimeTimestamp, endTimeTimestamp };
          } else if (valueKey === 'textPropValue') { // 文本
            _new_value = _new_value ?? null;
          } else if (valueKey === 'radioPropValue') { // 单选
            _new_value = _new_value || {};
          } else if (['checkBoxPropValuesList', 'materialPropValuesList'].includes(valueKey)) { // 多选, 素材
            _new_value = _new_value || [];
          }
          _item[valueKey] = _new_value;
          return _item;
        });
        this.$emit('change', _values);
      }
    }
  },
  methods: {
    ...mapActions(["updateCatePropShopIndex"]),
    async fetch_props(isUpdate) {
      isUpdate && this.updateCatePropShopIndex("kuaishou")
      let res = await getCategoryProps({categoryId: this.cid})
      this.brandPropConfig = null
      if (res && res.categoryPropSwitch) {
        // 有类目属性信息且状态是开启
        this.propConfigs = res.propConfigs.filter(item => {
          if (item.propName === '品牌') {
            this.brandPropConfig = item
            return false
          }
          return true
        })
        this.initValues()
      } else {
        return false
      }
      if (res) {
        // 更新退货规则下拉框选项
        this.$emit('refundRuleChange', res.categoryConfig || {}, this.brandPropConfig)
      }
    },
    // 初始化类目属性数据结构
    initValues(updatedValues) {
      const propConfigs = this.propConfigs;
      const values = updatedValues || this.values;
      let init_values = []
      propConfigs.forEach(item => {
        let inputType = inputTypeMaps[item.propInputType]
        let v = {
          propId: item.propId,
          propName: item.propName,
          sortNum: item.sortNum,
          inputType
        }
        let valueItem = null;
        let oldValue = values.find(v => v.propId === item.propId)
        if (oldValue && !this.categoryIdChange) {
          // 老值回显问题
          valueItem = {
            ...oldValue,
            inputType   // inputType 需要根据propConfig的propInputType来匹配，不能以保存的老数据为准， 用户可能会改变该属性的发布规则
          }
        } else {
          const valueKey = valueKeyMaps[v.inputType]
          if (valueKey) {
            // 文本类服务器只存null
            v[valueKey] =
              valueKey === 'textPropValue'
              ? null : valueKey === 'radioPropValue' // 单选类型空值需要转成对象
              ? {} : ['checkBoxPropValuesList', 'materialPropValuesList'].includes(valueKey) // 多选类型空值需要转成数组
              ? [] : '';
          }
          valueItem = v
        }
        if (item?.unitProp?.length) {
            const _val = valueItem[valueKeyMaps[valueItem.inputType]] || ''
            let unitName = '';
            let inputValue = _val;
            let findUnit = {}
            if(_val) {
              // 把平台下载的带单位的值拆分成 值 + 单位， 两个字段
              let match = _val.match(/(\d+(\.\d+)?)(.*)/);
              if (match?.length) {
                unitName = match[3] || '';
                inputValue = match[1] || ''
              }
              findUnit = item.unitProp.find(unitItem => unitItem.unitPropValueName == unitName) || {}
            }
            valueItem.unitPropValueId = findUnit.unitPropValueId || ''
            valueItem.unitPropValueName = findUnit.unitPropValueName || ''
            valueItem[valueKeyMaps[valueItem.inputType]] = inputValue
          }
        Object.values(valueKeyMaps).map(valueKey => {
          if(valueKey !== valueKeyMaps[valueItem.inputType]) {
            delete valueItem[valueKey]
          }
        })
        init_values.push(valueItem)
        this.setRulesByPropConfig(item)
      })
      let vleng = values && values.length ? values.length : 0;
      if (this.categoryIdChange || updatedValues || !vleng || vleng < init_values.length || this.firstLoad) {
        this.$emit('change', init_values)
        this.categoryIdChange = false
        this.firstLoad = false
      }
      this.$nextTick(() => {
        this.validate()
      })
    },
    setRulesByPropConfig(config) {
      let rules = []
      const { required, propInputType, propInputConfig, unitProp, propId } = config
      if (required) {
        rules.push({ required: true, message: `请完善${config.propName}` })
        if (propInputType === 'RADIO') {
          rules.push({validator: this._genRadioRules(config)})
        }
      }
      if (propInputType === "IMAGE" && propInputConfig?.imageInputConfig) { 
        rules.push({validator: this._genImgRules(config)})
      }
      if (propInputType === "TEXT" && propInputConfig?.inputFormatConfig) {   
        rules.push({validator: this._genTextRules(config)})
      }
      if (propInputType === "MATERIAL") {
        rules.push({validator: this._genMaterialRules(config)})
      }
      if (unitProp?.length) {
        rules.push({validator: this._genUnitRules(config)})
      }
      this.$set(this.rules, propId, rules)
    },
    validate() {
      return new Promise((resolve) => {
          this.$refs.form.validate(valid => {
              resolve(valid);
          })
      })
    },
    // 根据动态配置生成单位的校验规则
    _genUnitRules(config) {
      const propId = config.propId
      const _this = this
      return function(rule, value, callback) {
        const unit = _this.unitForm[propId]
        if (value && !unit) {
          callback(new Error(`${config.propName}请选择单位`))
        } else {
          callback()
        }
      }
    },
    // 根据动态配置生成图片的校验规则
    _genImgRules(config){
      const imgRules = config.propInputConfig.imageInputConfig
      const that = this
      return async function(rule, value, callback) {
        const imgs = _filterInvalidImg(value)
        if(!imgs.length) return callback()
        if (imgRules.maxCount && imgs.length > imgRules.maxCount) {
          callback(new Error(`${config.propName}图片不能超过${imgRules.maxCount}张`))
        } else if (imgRules.minCount && imgs.length < imgRules.minCount) {
          callback(new Error(`${config.propName}图片至少上传${imgRules.minCount}张`))
        } else if (that.$refs[`${config.propId}_img`]) {
          let errMsg = await that.$refs[`${config.propId}_img`][0].method_validImage()
          errMsg ? callback(new Error(errMsg)) : callback();
        }  else {
          callback()
        }
      }
    },
    // 根据动态配置生成文本校验规则
    _genTextRules(config) {
      const isRequired = config.required
      const textRules = config.propInputConfig.inputFormatConfig
      // 字符长度限制
      const limitRegStr = !textRules.useLimit ? '{0,}' : `{${textRules.min},${textRules.max ? textRules.max : ''}}`
      // 最终正则字符串
      const regText = `${textRules.patternList.join('')}`;
      let reg = new RegExp();
      if (!textRules.patternList || textRules.patternList.length === 0) {
      } else if (/^\([^]+\)$/.test(regText) && textRules.patternList.length === 1) {
        reg = new RegExp(`^${regText}${limitRegStr}$`)
      } else {
        reg = new RegExp(`^[${regText}]${limitRegStr}$`)
      }
      // const regText = `^${textRules.patternList.join('')}${limitRegStr}$`
      // const reg = (textRules.patternList && textRules.patternList.length) ? new RegExp(regText) : false

      return function(rule, value, callback) {
        if (reg.test(value)) {
          callback()
        } else if (value) {
          callback(new Error(textRules.message))
        } else if (isRequired) {
          callback(new Error('必填'))
        } else {
          callback()
        }
      }
    },
    // 生成校验单选不为空
    _genRadioRules(config) {
      return function(rule, value, callback) {
        if (!value) {
          callback(new Error('请选择'))
        } else if (value && !value.propValue) {
          callback(new Error('请选择'))
        } else {
          callback()
        }
      }
    },
    // 根据动态配置生成材质校验规则
    _genMaterialRules(config) {
      const isRequired = config.required
      return function(rule, value, callback) {
        if(isRequired && !value?.length) {
          return callback(new Error('请添加材质'))
        }
        const ids =[]
        let errMsg = ''
        let totalNumber = 0
        let hasContentNumber = false
        const hasError = (value || []).some(item => {
          if(!item.propValueId || (item.needContentNumber && !item.content)) {
            errMsg = '请完善材质'
            return true
          }
          if(ids.includes(item.propValueId)) {
            errMsg = '材质不能重复'
            return true
          }
          ids.push(item.propValueId)
          if(item.needContentNumber) {
            hasContentNumber = true
            totalNumber += Number(item.content)
          }
        })
        if (hasError) {
          return callback(new Error(errMsg))
        } 
        if(hasContentNumber && totalNumber !== 100) {
          return callback(new Error('材质百分比之和必须100%'))
        }
        return callback()
      }
    },
    // 根据prePropValues结合当前表单判断当前控件是否要展示
    preConstraintCanshow(prePropValues) {
      let show = true
      prePropValues.forEach(prop => {
        // 遍历获取先置控件的id及他所需要的值的id
        const values = prop.propValues.map(item => item.propValueId)
        // 当前表单值
        const curr_value = this.form[prop.propId] || {}
         // 可能会存在多选情况
         if (curr_value instanceof Array) {
          const isExist = curr_value.some(item => {
            return values.includes(item.propValueId)
          });
          if (!isExist) {
            show = false
          }
        } else if (!values.includes(curr_value.propValueId)) {
          show = false
        }
      })
      return show
    },
    // 单位变更时同步到 values
    handleUnitChange(propId) {
      if (!this.values?.length) return;
      const _values = this.values.map(item => {
        if (item.propId === propId) {
          const unitData = this.unitForm[propId];
          const _item = { ...item };
          if (unitData) {
            _item.unitPropValueId = unitData.unitPropValueId;
            _item.unitPropValueName = unitData.unitPropValueName;
          } else {
            _item.unitPropValueId = '';
            _item.unitPropValueName = '';
          }
          return _item;
        }
        return item;
      });
      this.$emit('change', _values);
    },
    // 提供给外部使用，用于过滤掉没达成preConstraintCanshow的字段
    // 这个目前是提交前必调用的方法，所以在此方法中加入单位补全方法，避免单位补全又走一次循环
    // 同时也对一些为空值的字端进行过滤，后端不需要空值的字段
    method_filterPreConstraintNoShow(data) {
      let finalData = []
      if(this.brandPropConfig) { // 品牌已经单独提出，每个店铺都单独处理，但是这里后端需要一个品牌空数据保存，所以加在这里
        finalData.push({
          propId: this.brandPropConfig.propId,
          propName: this.brandPropConfig.propName,
          inputType: '8',
          sortNum: this.brandPropConfig.sortNum,
          radioPropValue: null,
        })
      }
      data.forEach(item => {
        const propId = item.propId
        const propConfig = this.propConfigs.find(conf => conf.propId === propId) // 找到此字段的配置
        const valueKey = valueKeyMaps[item.inputType] // 当前字段的值的key
        if (propConfig?.preConstraint && !this.preConstraintCanshow(propConfig?.prePropValues)) {
          // 若没达到preConstraintCanshow则过滤
          return;
        }

        if (valueKey) {
          // 对一些为空值的字端进行过滤
          if (['textPropValue', 'radioPropValue', 'checkBoxPropValuesList', 'materialPropValuesList'].includes(valueKey)) {
            if(_.isEmpty(item[valueKey])) {
              return ;
            }
            if(Object.prototype.toString.call(item[valueKey]) === '[object Object]' && !item[valueKey].propValue) {
              return ;
            }
          } else if (!item[valueKey]) {
            return ;
          }
        }

        let _item = {...item}
        if (propConfig?.unitProp?.length) {
          // 若有单位配置则补全单位
          const unitData = this.unitForm[propId]
          _item.unitPropValueId = unitData.unitPropValueId
          _item.unitPropValueName = unitData.unitPropValueName
        }
        finalData.push(_item)
      })
      return finalData
    },
  },
  beforeDestroy() {
  } 
}
</script>

<style lang="scss" scoped>
.category-attr {
  align-items: flex-start;
  position: relative;
  .smart-match-tip {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      background-color: #fffbe6;
      border: 1px solid #ffe58f;
      border-radius: 2px;
      padding: 10px;
      font-size: 14px;
      width: 100%;
      color: #6c6d6f;
      .icon {
          color: #faad14;
          font-size: 24px;
          margin-right: 5px;
      }
      .match-infos {
          font-size: 12px;
          margin-left: 30px;
      }
      .fill-btn {
          margin-right: 30px;
      }
      .delete-btn {
          position: absolute;
          top: 10px;
          right: 20px;
          color: #979494;
      }
  }
  .attr-item {
    width: 245px !important;
    margin-bottom: 28px !important;
  }
  .long-attr-item {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    padding: 0;
  }
   .update-brand {
        position: absolute;
        left: 20px;
        bottom: 0px;
        font-size: 12px;
    }
}
</style>